




















































import {
  Vue, Component, Prop, PropSync,
} from 'vue-property-decorator';
import Card from '@/components/Card/StandardCard/index.vue';
import TextButton from '@/components/Buttons/TextButton/index.vue';
import ConfigurationAdd from '@/components/Form/Configuration/ConfigurationAdd/index.vue';

@Component({
  components: {
    Card,
    TextButton,
    ConfigurationAdd,
  },
})
export default class ConfigurationType extends Vue {
  @Prop({}) typeLabel!: string;

  @Prop({}) sectorProps!: string;

  @Prop({}) documentHeadline!: string;

  @Prop({}) label!: string;

  @PropSync('listArray', {}) listArraySync!: any;

  public edit: boolean = false;

  public close() {
    this.edit = false;
  }
}
